<div class="page-padding-y page-padding-x">
  
  <div
    class="flex flex-col gap-4 sm:flex-row"
  >
    <app-search-refinement-panel 
      id="search-refinement-panel"
      class="flex flex-col min-w-64 max-w-64"
    ></app-search-refinement-panel>
  
    <div class="flex w-full flex-col gap-4">
      <app-search-result-list
        class="flex w-full"
        [isOnGlobalSearchPage]="true"
        [showPagination]="true"
      ></app-search-result-list>

    </div>
  </div>
</div>
